import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaTrash, FaEdit, FaSave, FaTimes } from 'react-icons/fa';
import formclasses from '../../Employee/AddEmployeeDirectory/AddEmployeeDirectory.module.css';
import classes from './ManagersTable.module.css';
import axios from 'axios';
import authContext from '../../../../AuthContext/authContext';
import { toast } from 'react-toastify';

const ManagersTable = ({
  managers,
  setManagers,
  formik,
  handleManagerChange,
  token,
  base_url,
}) => {
    console.log(managers, "managers")
  const [editingId, setEditingId] = useState(null);
  const [isSaving, setIsSaving] = useState(null); // null or id of the row being saved
  const [editData, setEditData] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [managerToDelete, setManagerToDelete] = useState(null);

  const handleEdit = (row) => {
    setEditingId(row.id);
    setEditData({ ...row });
  };

  const validateManager = (manager) => {
    const errors = {};
    const nameRegExp = /^[A-Za-z\s]+$/;
    
    // Name validation
    if (!manager.name || manager.name.trim() === '') {
      errors.name = 'Manager name is required';
    } else if (!nameRegExp.test(manager.name)) {
      errors.name = 'Name can only contain letters and spaces';
    } else if (manager.name.length < 2) {
      errors.name = 'Name must be at least 2 characters';
    } else if (manager.name.length > 50) {
      errors.name = 'Name cannot exceed 50 characters';
    }
    
    // Email validation
    if (!manager.email) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(manager.email)) {
      errors.email = 'Please enter a valid email address';
    } else if (manager.email.length > 100) {
      errors.email = 'Email cannot exceed 100 characters';
    }
    
    // Phone validation
    if (!manager.phone) {
      errors.phone = 'Phone number is required';
    } else if (!/^[0-9]{10}$/.test(manager.phone)) {
      errors.phone = 'Please enter a valid 10-digit phone number';
    }
    
    // Password validation (only for new managers)
    if (!manager._id) {
      if (!manager.password) {
        errors.password = 'Password is required';
      } else if (manager.password.length < 8) {
        errors.password = 'Password must be at least 8 characters long';
      } else if (manager.password.length > 50) {
        errors.password = 'Password cannot exceed 50 characters';
      } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(manager.password)) {
        errors.password = 'Must contain at least one uppercase, one lowercase, and one number';
      }
    }
    
    return Object.keys(errors).length === 0 ? null : errors;
  };

  const handleSave = async (id) => {
    setIsSaving(id); // Set the ID of the row being saved
    // Validate the current manager being edited
    const validationErrors = validateManager(editData);
    
    if (validationErrors) {
      // Show validation errors to the user
      setIsSaving(null);
      Object.values(validationErrors).forEach(error => {
        toast.error(error);
      });
      return;
    }

    try {
      const updatedManagers = managers.map(manager =>
        manager.id === id ? { ...editData } : manager
      );
      
      // Update state
      setManagers(updatedManagers);
      setEditingId(null);
      
      // Update Formik values and submit form
      if (formik) {
        formik.setFieldValue('managers', updatedManagers, false);
        // Add a small delay to ensure state is updated before submit
        setTimeout(() => {
            // Only submit if there's a formik submit handler
            if (formik.handleSubmit) {
                formik.handleSubmit();
            }
        }, 100); // 100ms delay
    }

    } catch (error) {
      console.error('Error saving manager:', error);
      toast.error('Error saving manager');
    } finally {
      setIsSaving(null);
    }
  };

  const handleCancel = (id) => {
    if (id.startsWith('new-')) {
      setManagers(managers.filter(manager => manager.id !== id));
    }
    setEditingId(null);
    setEditData({});
  };

  const handleInputChange = (e, field) => {
    setEditData({ ...editData, [field]: e.target.value });
  };

  const handleDeleteConfirm = async () => {
    if (!managerToDelete) return;
    
    const { id, manager } = managerToDelete;
    
    try {
      // If manager exists on the server, delete it first
      if (manager._id) {
        await axios({
          method: "DELETE",
          url: `${base_url}/user/locationManager/${manager._id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
      }
      console.log(managerToDelete,"managerToDelete")
      // Update the managers list without triggering form update
      setManagers(prevManagers => {
        const updatedManagers = prevManagers.filter(m => m.id !== id);
        // Manually update formik values to prevent form submission
        if (formik) {
          formik.setFieldValue('managers', updatedManagers, false);
        }
        return updatedManagers;
      });
      
      setShowDeleteModal(false);
      setManagerToDelete(null);
      
      // Show success message if needed
      toast.success('Manager deleted successfully');
    } catch (err) {
      console.error('Error deleting manager:', err);
      // Show error message if needed
      toast.error('Failed to delete manager');
    }
  };

  const addManager = () => {
    const newManager = {
      id: `new-${Date.now()}`,
      name: "",
      email: "",
      phone: "",
      password: "",
      _id: "",
      isEditing: true
    };
    setManagers([...managers, newManager]);
    setEditingId(newManager.id);
    setEditData(newManager);
  };

  console.log(isSaving,"isSaving")
  const baseColumns = [
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
      cell: row => editingId === row.id ? (
        <input
          type="text"
          value={editData.name || ''}
          onChange={(e) => handleInputChange(e, 'name')}
          className={formclasses.tableInput}
        />
      ) : row.name
    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true,
      cell: row => editingId === row.id ? (
        <input
          type="email"
          value={editData.email || ''}
          onChange={(e) => handleInputChange(e, 'email')}
          className={formclasses.tableInput}
        />
      ) : row.email
    },
    {
      name: 'Phone',
      selector: row => row.phone,
      sortable: true,
      cell: row => editingId === row.id ? (
        <input
          type="text"
          value={editData.phone || ''}
          onChange={(e) => handleInputChange(e, 'phone')}
          className={formclasses.tableInput}
        />
      ) : row.phone
    }
  ];

  // Add User Type column only when not editing
  const columns = [
    ...baseColumns,
    ...(editingId === null ? [{
      name: 'User Type',
      selector: row => row.user_type,
      sortable: true,
      cell: row => row.user_type || 'N/A',
      omit: editingId !== null
    }] : []),
    {
      name: 'Password',
      selector: row => row.password ? '••••••' : 'Not set',
      cell: row => editingId === row.id ? (
        <input
          type="password"
          value={editData.password || ''}
          onChange={(e) => handleInputChange(e, 'password')}
          placeholder={row._id ? 'Leave blank to keep current' : 'Required'}
          className={formclasses.tableInput}
        />
      ) : (row.password ? '••••••' : '••••••')
    },
    {
      name: 'Actions',
      cell: row => (
        <div className={classes.actionButtons}>
          {editingId === row.id ? (
            <>
              <button
                type="button"
                onClick={() => !isSaving && handleSave(row.id)}
                className={`${classes.iconButton} ${isSaving === row.id ? classes.disabledButton : ''}`}
                title="Save"
                disabled={!!isSaving}
              >
                {isSaving === row.id ? (
                  <div className={classes.loader} />
                ) : (
                  <FaSave />
                )}
              </button>
              <button
                type="button"
                onClick={() => handleCancel(row.id)}
                className={classes.iconButton}
                title="Cancel"
              >
                <FaTimes />
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                onClick={() => handleEdit(row)}
                className={classes.iconButton}
                disabled={editingId !== null}
                title="Edit"
              >
                {isSaving ? (
                  <div className={classes.loader} />
                ) : ( 
                  <FaEdit />)
                }
              </button>
              {row.deletable !== false && managers.length > 1 && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setManagerToDelete({ id: row.id, manager: row });
                    setShowDeleteModal(true);
                    return false;
                  }}
                  className={classes.iconButton}
                  disabled={editingId !== null}
                  title="Delete"
                >
                  {isSaving ? (
                    <div className={classes.loader} />
                  ) : ( 
                    <FaTrash />
                  )}
                </button>
              )}
            </>
          )}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  return (
    <div className={classes.managerSection}>
      <div className={classes.managerHeader}>
        <h4>Managers</h4>
        <button
          type="button"
          onClick={addManager}
          className={classes.addManagerBtn}
          disabled={editingId !== null || managers.length >= 2}
        >
          + Add Manager
        </button>
      </div>
      <DataTable
        columns={columns}
        data={managers}
        noHeader
        responsive
        customStyles={{
          headCells: {
            style: {
              fontWeight: 'bold',
              backgroundColor: '#f8f9fa',
            },
          },
          rows: {
            style: {
              minHeight: '60px',
            },
          },
          cells: {
            style: {
              padding: '8px',
            },
          },
        }}
      />
      {formik.touched.managers && formik.errors.managers && (
  <div className={formclasses.errorMessage}>
    {(() => {
      // If it's a string error, show it directly
      if (typeof formik.errors.managers === 'string') {
        return formik.errors.managers;
      }
      
      // If it's an array, find and show the first error message
      if (Array.isArray(formik.errors.managers)) {
        const errorObj = formik.errors.managers.find(item => item && typeof item === 'object');
        if (errorObj) {
          // Get the first error message from the error object
          return Object.values(errorObj)[0];
        }
      }
      
      // Default fallback
      return 'Please fix validation errors in the table.';
    })()}
  </div>
)}
      
      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className={classes.modalOverlay}>
          <div className={classes.modalContent}>
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this manager?</p>
            <div className={classes.modalActions}>
              <button 
                type="button"
                className={classes.cancelButton}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowDeleteModal(false);
                  return false;
                }}
              >
                Cancel
              </button>
              <button 
                type="button"
                className={classes.deleteButton}
                onClick={async (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  await handleDeleteConfirm();
                  return false;
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagersTable;